import React from 'react';
import './Navbar.css';
import logo from './../../awesom/laptop.png';


const Navbar = () => {
	return (
		<div className="navbar">
			<div className="navbar_logo">
				<img src={logo} alt="logo"/>
			</div>
			<div className="navbar_links">
				<a href="#about">ABOUT</a>		
				<a href="#skills">SKILLS</a>
				<a href="#reviews">REVIEWS</a>
				<a href="#order">ORDER</a>
			</div>
		</div>
		)
}
export default Navbar;